import { render, staticRenderFns } from "./ArtworkTextNote.vue?vue&type=template&id=5e0e2757&scoped=true"
import script from "./ArtworkTextNote.vue?vue&type=script&lang=js"
export * from "./ArtworkTextNote.vue?vue&type=script&lang=js"
import style0 from "./ArtworkTextNote.vue?vue&type=style&index=0&id=5e0e2757&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e0e2757",
  null
  
)

export default component.exports